import React from 'react';
import "./spinner.css";

export default function Spinner(){
    return(
        <div>
            <div class="shapes"></div>
        </div>
    );   
}